import { FeatureLink } from "@softmax/web-features/navigation";

import { leaguesUrl } from "@softmax/web-features/site/records";

import type { SiteHeaderControls } from "../use-site-header";

import { isNavigationClick } from "../link-click";

import joinedStyles from "../account-pill.module.css";

import { Item } from "../pill-menu-items";

import { HeaderDropdown } from "./pill-header-dropdown";

import type { HeaderMenu } from "./header-menu";

export function HeaderMenuItem({
  menu,
  ids,
  panel,
  hydrated,
  onNavigate,
  setPanel,
}: Pick<SiteHeaderControls, "ids" | "panel" | "onNavigate" | "setPanel"> & {
  readonly menu: HeaderMenu;
  readonly hydrated: boolean;
}) {
  return menu.href && menu.links.length === 0 ? (
    <li key={menu.key} className={joinedStyles.slot}>
      <FeatureLink
        href={menu.href}
        className={joinedStyles.link}
        onClick={(event) => {
          if (isNavigationClick(event)) onNavigate(menu.href!);
        }}
      >
        {menu.heading}
      </FeatureLink>
    </li>
  ) : (
    <HeaderDropdown
      key={menu.key}
      label={menu.heading}
      href={menu.href}
      id={`${ids}-menu:${menu.key}`}
      open={panel === `menu:${menu.key}`}
      hydrated={hydrated}
      onOpenChange={(next) => setPanel(next ? `menu:${menu.key}` : null)}
      onNavigate={onNavigate}
    >
      {menu.links
        .filter((link) => menu.key !== "browse" || link.href !== leaguesUrl)
        .map((link) => (
          <Item
            key={link.href + link.label}
            link={link}
            styles={joinedStyles}
            onNavigate={onNavigate}
          />
        ))}
    </HeaderDropdown>
  );
}
